import React, { useState } from "react";
import "./Portfolio.css";
import Menu from "./Menu";
import { RiGithubLine, RiLink } from "react-icons/ri";
import { motion } from "framer-motion";

const Portfolio = () => {
  const [items, setItems] = useState(Menu);
  const [activeFilter, setActiveFilter] = useState("All");

  const filters = ["All", "Web App", "ML", "Flask"];

  const filterItems = (tag) => {
    if (tag === "All") {
      setItems(Menu);
      setActiveFilter("All");
      return;
    }
    const filtered = Menu.filter((project) => project.tags.includes(tag));
    setItems(filtered);
    setActiveFilter(tag);
  };

  return (
    <section className="portfolio container section" id="portfolio">
      <h2 className="section__title">Projects</h2>

      <div className="portfolio__filters">
        {filters.map((tag) => (
          <span
            key={tag}
            className={activeFilter === tag ? "portfolio__item portfolio__item-active" : "portfolio__item"}
            onClick={() => filterItems(tag)}
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="portfolio__container">
        {items.map((project, index) => {
          const { title, image, githubUrl, youtubeUrl, tags, description } = project;
          return (
            <motion.div
              layout
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="portfolio__card"
              key={index}
            >
              <div className="portfolio__thumbnail">
                <img src={image} alt={title} className="portfolio__img" />
                <div className="portfolio__mask"></div>
                <span className="portfolio__category">{tags.join(", ")}</span>
              </div>

              <h3 className="portfolio__title">{title}</h3>
              <p className="portfolio__description">{description}</p>

              <div className="portfolio__buttons">
                {youtubeUrl && (
                  <a href={youtubeUrl} target="_blank" rel="noreferrer" className="portfolio__button">
                    <RiLink />
                  </a>
                )}
                {githubUrl && (
                  <a href={githubUrl} target="_blank" rel="noreferrer" className="portfolio__github-button">
                    <RiGithubLine />
                  </a>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
